import * as React from 'react'

import createContext from 'modules/core/hooks/createContext'
import { useCallback } from 'modules/core/hooks/useCallback'

import type { FiltersDispatch } from './reducers/filter'
import FilterReducer, { FilterState, initialFiltersState } from './reducers/filter'

type Context = [FilterState, FiltersDispatch]

const { context: FilterContext, hook: useFilters } = createContext<Context>()

const FiltersProvider = ({ children }: React.PropsWithChildren<object>) => {
  const memoizedReducer = useCallback(FilterReducer, [])
  const [state, dispatch] = React.useReducer(memoizedReducer, initialFiltersState())

  return <FilterContext.Provider value={[state, dispatch]}>{children}</FilterContext.Provider>
}

export { FiltersProvider, useFilters }
